/*
 * FH 2026-09-28: star ratings on collection product cards.
 * The Smart Product Filter cards already contain an empty Rivyo slot (.rivyo_product_review_badge[data-handle]);
 * this fills it from the collection's Rivyo ratings (templates/collection.fh-ratings.liquid, one request per
 * collection, cached for 30 minutes in the browser tab). Cards with no reviews stay as they are.
 * Stars sit above the product name (Zeplin collection design). Screen readers hear one phrase per card, e.g. "Rated 4.9 out of 5 stars, 31 reviews".
 * Rollback: delete the fh-card-stars line in snippets/meta-tags.liquid.
 */
(function () {
  'use strict';
  var m = window.location.pathname.match(/^\/collections\/([^\/]+)\/?$/);
  if (!m || !window.fetch) return;
  var handle = m[1];
  var KEY = 'fhStars:' + handle;
  var ratings = null;

  function load(page) {
    return fetch('/collections/' + handle + '?view=fh-ratings&page=' + page, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('ratings ' + r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t); });
  }

  function getRatings() {
    try {
      var c = JSON.parse(window.sessionStorage.getItem(KEY) || 'null');
      if (c && Date.now() - c.t < 1800000) return Promise.resolve(c.r);
    } catch (e) {}
    return load(1).then(function (d) {
      var r = d.r || {};
      var extra = [];
      for (var p = 2; p <= Math.min(d.pages || 1, 4); p++) extra.push(load(p));
      return Promise.all(extra).then(function (more) {
        more.forEach(function (x) { var o = x.r || {}; for (var k in o) r[k] = o[k]; });
        try { window.sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), r: r })); } catch (e) {}
        return r;
      });
    });
  }

  function fill() {
    if (!ratings) return;
    var slots = document.querySelectorAll('.rivyo_product_review_badge[data-handle]');
    for (var i = 0; i < slots.length; i++) {
      var el = slots[i];
      if (el.childElementCount || el.getAttribute('data-fh-stars')) continue;
      var infoBox = el.closest('.spf-product__info');
      if (infoBox && infoBox.querySelector('.fh-card-stars')) { el.setAttribute('data-fh-stars', '1'); continue; }
      el.setAttribute('data-fh-stars', '1');
      var r = ratings[el.getAttribute('data-handle')];
      if (!r || !(r[1] > 0)) continue;
      var value = (Math.round(r[0] * 10) / 10).toFixed(1);
      var count = r[1];
      // Stars are 16 units wide with 4-unit gaps (96 units in all), so fill whole stars plus part of the next one.
      var rating = Math.max(0, Math.min(5, r[0]));
      var whole = Math.floor(rating);
      var pct = rating >= 5 ? '100' : (((whole * 20) + (rating - whole) * 16) / 96 * 100).toFixed(1);
      var box = document.createElement('div');
      box.className = 'fh-card-stars';
      box.setAttribute('role', 'img');
      box.setAttribute('aria-label', 'Rated ' + value + ' out of 5 stars, ' + count + (count === 1 ? ' review' : ' reviews'));
      box.innerHTML = '<span class="fh-card-stars__icons" style="--fh-pct:' + pct + '%"></span>' +
        '<span class="fh-card-stars__count">(' + count + ')</span>';
      // Show the stars above the product name, as in the collection design.
      var card = el.closest('.spf-product__info') || el.parentNode;
      var title = card.querySelector('.spf-product-card__title');
      if (title && title.parentNode === card) card.insertBefore(box, title);
      else el.appendChild(box);
    }
  }

  function start() {
    getRatings().then(function (r) {
      ratings = r;
      fill();
      // The filter app redraws the grid when shoppers filter, sort or page; fill the new cards too.
      var timer;
      new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(fill, 150); })
        .observe(document.body, { childList: true, subtree: true });
    }).catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();